<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">{{ topTitle }}</div>
      <div class="title--button">
        <printViewBtn
          :changeList="changeList"
          :modules="138"
          :printFun="pmgtPurchasesInquiryCooperativeDoc_view"
        ></printViewBtn>
      </div>
    </div>
    <hr style="border-top: #dcdfe6" />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="titleData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    ></myHtml>
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <el-dialog
      :visible.sync="dialogState.show1"
      :close-on-click-modal="false"
      class="dialog"
      :title="'回复'"
      width="65%"
      @close="dialogClose"
    >
      <el-descriptions size="small" :column="1" border :label-style="labelStyle">
        <el-descriptions-item contentStyle="width: 220px">
          <template slot="label">当前报价(含税)</template>
          <el-input
            style="width: 100%"
            v-model="dialogData.baseMaterialQuotationUnitprice"
            placeholder="当前报价(含税)"
            @input="inputNumberClick('baseMaterialQuotationUnitprice')"
            type="number"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 220px">
          <template slot="label">税率</template>
          <el-input
            style="width: 100%"
            v-model="dialogData.baseTaxRate"
            @input="inputNumberClick('baseTaxRate')"
            placeholder="税率"
            type="number"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 220px">
          <template slot="label">当前报价(未税)</template>
          <el-input
            style="width: 100%"
            v-model="dialogData.baseMaterialQuotationUnitpriceUntaxed"
            placeholder="当前报价(未税)"
            @input="inputNumberClick('baseMaterialQuotationUnitpriceUntaxed')"
            type="number"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item contentStyle="width: 220px">
          <template slot="label">预计交期</template>
          <el-date-picker
            style="width: 100%"
            v-model="dialogData.baseCanDeliveryDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="预计交期"
          >
          </el-date-picker>
        </el-descriptions-item>
      </el-descriptions>
      <div style="margin-top: 20px; text-align: center">
        <el-button type="primary" @click="dialogSaveOk()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selcetSetting,
  updateSetting,
  _debounce,
  customMenu,
  subFloat,
  mulFloat,
  divFloat,
  accAdd,
  year,
  month,
  day,
} from "@/utils/myUtils";

import {
  pmgtPurchasesInquiryCooperativeDoc_selectPurchaseInquiryCooperativeList,
  pmgtPurchasesInquiryCooperativeDoc_view,
  pmgtPurchasesInquiryCooperativeDoc_upddatePurchaseInquiryCooperativeSupplierWithQuotationUnitPrice,
} from "@/api/myController/purchase";
export default {
  name: "quotation_inquiry",
  props: {
    // 页面传进来的值
    titleData: {
      default: () => ({
        type: 1,
      }),
    },
    topTitle: {
      type: String,
      default: "询价单",
    },
  },
  components: {},
  data() {
    return {
      homeKey: "xt_quotation_inquiryOne",
      pmgtPurchasesInquiryCooperativeDoc_view,
      // *************主表状态
      labelStyle: {
        "text-align": "center",
        "font-weight": "600",
        width: "110px",
        "word-break": "keep-all",
      },
      // -------------------------
      dialogData: {},
      dialogState: {
        show1: false,
      },
      // ------------------------

      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      // 操作栏数据
      operationTitleData: [],
      // 排序
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      // 操作栏数据
      titleOperationTitleData: [
        // {
        //   name: "基本信息",
        //   value: "searchString",
        //   type: "text",
        // },

        {
          id: 14,
          name: "询价阶段",
          value: "type",
          btnList: [
            { name: "全部", value: 0 },
            { name: "进行中", value: 1 },
            { name: "已结束", value: 2 },
          ],
          type: "buttonList",
        },
        { name: "", type: "line" },
        { name: "刷新", type: "button" },
      ],
      listLoading: false,
      columnType: "columnAll", // columnIndex序号,columnBox复选框
      // 按钮集合
      tableBtnList: ["回复"],
      // 表内容
      list: [],
      // 表头
      titleList: [
        {
          id: 1,
          name: "询价单编号",
          value: "purchasesInquiryDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          color: "#409eff",
          canEdit: false,
          width: 120,
        },
        {
          id: 1,
          name: "询价单名称",
          value: "docName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 1,
          name: "询价人",
          value: "baseInquiryPersonName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 1,
          name: "询价有效期",
          value: "baseInquiryEffectiveTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: "询价日期",
          value: "baseInquiryTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: "中标状态",
          value: "winTheBid",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "待开标",
              value: 0,
              color: "white",
              backGroundColor: "rgb(79,129,246)",
            },
            {
              label: "已中标",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
            },
            {
              label: "未中标",
              value: 2,
              color: "white",
              backGroundColor: "rgb(220,223,230)",
            },
          ],
          canEdit: false,
          width: 180,
        },
        {
          id: 1,
          name: "产品图片", // 必传
          value: "baseImgUrl", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "image", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: false, // 是否不可编辑，true可编辑，false不可编辑
          width: 95,
        },
        {
          id: 0,
          name: "产品编号", // 必传
          value: "baseMaterialNumber", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false,
          canEdit: true,
          width: 120,
        },
        {
          id: 1,
          name: "产品名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "customTable",
          alwaysEditState: false,
          canEdit: true,
          width: 120,
        },
        {
          id: 1,
          name: "产品图纸",
          value: "baseDrawingFile",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          alwaysEditState: false,
          canEdit: true,
          width: 70,
        },
        {
          id: 1,
          name: "产品附件",
          value: "baseFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          alwaysEditState: false,
          canEdit: true,
          width: 70,
        },
        {
          id: 1,
          name: "3D模型文件",
          value: "baseModelFile",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          alwaysEditState: false,
          canEdit: true,
          width: 70,
        },
        {
          id: 2,
          name: "产品规格",
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: true,
          width: 180,
        },
        {
          id: 8,
          name: "预计采购数量",
          value: "baseAmount",
          fixedState: false,
          isShow: true,
          dataType: "numberAccuracy",
          alwaysEditState: false,
          canEdit: true,
          width: 90,
        },
        {
          id: 7,
          name: "单位",
          value: "baseMaterialUnitName",
          fixedState: false,
          isShow: true,
          dataType: "customTable",
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false,
          canEdit: true,
          width: 90,
        },
        {
          id: 4,
          name: "目标含税单价",
          value: "baseMaterialUnitprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          alwaysEditState: false,
          canEdit: true,
          width: 90,
        },
        {
          id: 5,
          name: "目标税率(%)",
          value: "baseTaxRate",
          fixedState: false,
          isShow: true,
          dataType: "number",
          alwaysEditState: false,
          canEdit: true,
          width: 90,
        },
        {
          id: 6,
          name: "目标未税单价",
          value: "baseMaterialUnitpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          alwaysEditState: false,
          canEdit: true,
          width: 90,
        },
        {
          id: 9,
          name: "目标含税小计",
          value: "baseMaterialTotalprice",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: true,
          width: 90,
        },
        {
          id: 10,
          name: "目标未税小计",
          value: "baseMaterialTotalpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: true,
          width: 90,
        },

        {
          id: 10,
          name: "当前报价(含税)",
          value: "baseMaterialQuotationUnitprice",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: true,
          width: 90,
        },
        {
          id: 10,
          name: "当前报价(未税)",
          value: "baseMaterialQuotationUnitpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: true,
          width: 110,
        },
        {
          id: 10,
          name: "预计交期",
          value: "baseCanDeliveryDate",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: true,
          width: 110,
        },
        {
          id: 11,
          name: "备注",
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: true,
          width: 120,
        },
      ],
      changeList: [],
    };
  },
  created() {
    this.$root.mainTitleList[this.homeKey] = JSON.parse(
      JSON.stringify(this.titleList)
    );
    this.getList();
    this.querySetting();
  },
  methods: {
    getList() {
      this.listLoading = true;
      this.list = [];
      this.changeList = [];
      pmgtPurchasesInquiryCooperativeDoc_selectPurchaseInquiryCooperativeList({
        orderParam: [this.orderParam],
        filter: this.titleData,
        type: this.titleData.type,
        pageParam: this.listQuery,
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
            try {
              if (item.baseBomVersion) {
                item.baseBomVersionV2 = "V" + item.baseBomVersion;
              } else {
                item.baseBomVersionV2 = "---";
              }
            } catch (error) {}
          });
          this.list = res.data.data.dataList;
          this.listQuery.total = res.data.data.totalCount;
        } else {
          this.list = [];
        }
        this.listLoading = false;
        this.$refs.myOperate?.dragSortShow();
      });
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case "全部":
          this.tableBtnList = [];
          this.getList();
          break;
        case "进行中":
          this.tableBtnList = ["回复"];
          this.getList();
          break;
        case "已结束":
          this.tableBtnList = [];
          this.getList();
          break;
        case "刷新":
          this.getList();
          break;
        default:
          break;
      }
    },
    inputNumberClick(val) {
      switch (val) {
        case "baseTaxRate":
        case "baseMaterialQuotationUnitprice":
          this.dialogData.baseMaterialQuotationUnitpriceUntaxed = divFloat(
            this.dialogData.baseMaterialQuotationUnitprice,
            accAdd(1, divFloat(this.dialogData.baseTaxRate, 100))
          );
          break;
        case "baseMaterialQuotationUnitpriceUntaxed":
          this.dialogData.baseMaterialQuotationUnitprice = mulFloat(
            this.dialogData.baseMaterialQuotationUnitpriceUntaxed,
            accAdd(1, divFloat(this.dialogData.baseTaxRate, 100))
          );
          break;
        default:
          break;
      }
    },
    dialogClose() {
      this.dialogState.show1 = false;
    },
    // 操作栏点击事件
    operationBtnClick(item, titleData) {
      switch (item.name) {
        case "刷新":
          this.getList();
          break;
        default:
          break;
      }
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case "回复":
          this.dialogData = row;
          this.dialogState.show1 = true;
          break;
        default:
          break;
      }
    },
    dialogSaveOk() {
      pmgtPurchasesInquiryCooperativeDoc_upddatePurchaseInquiryCooperativeSupplierWithQuotationUnitPrice(
        { pidsDto: this.dialogData }
      ).then((res) => {
        this.$message.success("操作成功！");
        this.dialogClose();
        this.getList();
      });
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        case "":
          break;

        default:
          break;
      }
    },
    // 多选
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    async querySetting() {
      let titleList = await selcetSetting(this.homeKey);
      if (titleList == null) {
        let listTwo = this.$root.mainTitleList[this.homeKey];
        let listThree = [];
        this.titleList = customMenu(listTwo, listTwo, listThree);
        updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
      } else {
        let listOne = titleList;
        let listTwo = this.$root.mainTitleList[this.homeKey];
        let listThree = [];
        this.titleList = customMenu(listOne, listTwo, listThree);
      }
      this.$refs.myOperate?.dragSortShow();
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
    // 重置
    async resetClick(titleList) {
      this.titleList = titleList;
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
        justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.spanText {
  color: #1476c3;
  font-size: 14px;
}

.operations {
  float: left;
  width: 200px;
  padding-top: 6px;
}

/*  修改页面样式 */

.title--font {
  text-align: left;
  padding: 10px 0;
}

::v-deep .operation {
  margin-bottom: 10px;
}

::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}

::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}

::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}

::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}

::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}

::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}

.title--button {
  right: 0;
  margin-top: 0.7%;
}
</style>
